import { render, staticRenderFns } from "./table-busy-loader.vue?vue&type=template&id=b2a19628&scoped=true&"
import script from "./table-busy-loader.vue?vue&type=script&lang=js&"
export * from "./table-busy-loader.vue?vue&type=script&lang=js&"
import style0 from "./table-busy-loader.vue?vue&type=style&index=0&id=b2a19628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a19628",
  null
  
)

export default component.exports